var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.flashcardInstruction)?_c('div',{staticClass:"flashcard-instruction"},[_c('icon',{attrs:{"name":"play-uui","variant":"155EEF"}}),_vm._v(" "),_c('span',[_vm._v("\n    "+_vm._s(_vm.flashcardInstruction)+"\n  ")])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }